var ICHI_CODE_TO_MODULE, collectInterventionCodes, get, getIchiModulePrefix, getModuleFromIchiCodeValue, getRecommendationModulesFromQuestion, stripHTML;

get = require('lodash').get;

stripHTML = require('lib/question_tags_helper').stripHTML;

ICHI_CODE_TO_MODULE = require('lib/data/planetary_health_ichi_code_modules');

getIchiModulePrefix = function(value) {
  var prefix;
  if (value == null) {
    return;
  }
  prefix = stripHTML(value).trim().toUpperCase().slice(0, 2);
  if (/^[A-Z]{2}$/.test(prefix)) {
    return prefix;
  }
};

getModuleFromIchiCodeValue = function(value) {
  var prefix;
  prefix = getIchiModulePrefix(value);
  if (prefix != null) {
    return ICHI_CODE_TO_MODULE[prefix];
  }
};

collectInterventionCodes = function(question) {
  var codes;
  if (question.type === 'diagnostic') {
    codes = _.values(get(question, 'codes.indexTest', {}));
    if (question.comparatorTestPresent) {
      codes = codes.concat(_.values(get(question, 'codes.comparatorTest', {})));
    }
    return codes;
  } else {
    return _.values(get(question, 'codes.intervention', {})).concat(_.values(get(question, 'codes.comparison', {})));
  }
};

getRecommendationModulesFromQuestion = function(question) {
  return _.chain(collectInterventionCodes(question)).filter(function(code) {
    return code.codeType === 'ICHI';
  }).map(function(code) {
    return getModuleFromIchiCodeValue(code.value);
  }).compact().uniq().sort().value();
};

module.exports = {
  collectInterventionCodes: collectInterventionCodes,
  getRecommendationModulesFromQuestion: getRecommendationModulesFromQuestion,
  ICHI_CODE_TO_MODULE: ICHI_CODE_TO_MODULE
};
